export default __webpack_public_path__ + "static/media/donate.b1e09e1f.webp";